export const getColorsTheme = () => JSON.parse(localStorage.getItem('theme') as string);
